/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable max-len */
import React from 'react';
import cx from 'classnames';

import Terms from './terms/Terms';

import styles from '../StaticContents.module.scss';

const PaymentTerms: React.FC = () => {
	return (
		<div className={cx(styles.staticContents, styles.container)}>
			<Terms />
		</div>
	);
};

export default PaymentTerms;
